/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_Faq_A1Inputs */

const en_guide_json_rest_api_faq_a1 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON is smaller, faster to parse, and natively supported in JavaScript. Most modern APIs chose JSON for better performance and simpler integration with web frontends.`)
};

const ko_guide_json_rest_api_faq_a1 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON은 더 작고, 파싱이 빠르며, JavaScript에서 네이티브로 지원됩니다. 대부분의 현대 API는 더 나은 성능과 웹 프론트엔드와의 간편한 통합을 위해 JSON을 선택했습니다.`)
};

const ja_guide_json_rest_api_faq_a1 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONはより小さく、パースが高速で、JavaScriptでネイティブにサポートされています。ほとんどの現代的なAPIは、より良いパフォーマンスとWebフロントエンドとの簡単な統合のためにJSONを選択しています。`)
};

/**
* | output |
* | --- |
* | "JSON is smaller, faster to parse, and natively supported in JavaScript. Most modern APIs chose JSON for better performance and simpler integration with web f..." |
*
* @param {Guide_Json_Rest_Api_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_faq_a1 = /** @type {((inputs?: Guide_Json_Rest_Api_Faq_A1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_Faq_A1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_faq_a1(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_faq_a1(inputs)
	return ja_guide_json_rest_api_faq_a1(inputs)
});